import { render, staticRenderFns } from "./ContractorPrices.vue?vue&type=template&id=0cd97a71&"
import script from "./ContractorPrices.vue?vue&type=script&lang=js&"
export * from "./ContractorPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports